import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import MainTitle from '../../../../components/MainTitle';
import ButtonBase from '../../../../components/Buttons/ButtonBase';
import TitlesProfile from '../../../../components/Profile/TitlesProfile';
import {
  cleanProposalData,
  loadProposalData,
  saveProposalData,
  updateProposal,
  getProposalsByPage,
  setProposalSelected,
} from '../../../../store/actions/ProposalsAction';
import {
  TextField,
} from '@material-ui/core';
import { showLoading, hideLoading } from '../../../../store/actions/LoadingActions';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import ReactQuill from 'react-quill';
import {
  uploadPDF,
  updateProposalById,
} from '../../../../configs/environments/firebase/firebaseApp';
import './ProposalBackCover.scss';
import { validationTitle } from '../../../../utils/validations';
import { saveAs } from 'file-saver';
var axios = require('axios');

const useStyles = makeStyles({
  ButtonBase: {
    padding: 0,
    margin: 0,
    width: 192,
    minWidth: 'initial',
    '@media (max-width: 768px)': {
      width: 144,
    },
  },
  TextField: {
    maxWidth: '100%',
    margin: 0,
  },
  linkStyle: {
    width: 192,
    margin: '0 24px 0 0',
    '&:last-child': {
      margin: 0,
    },
    '@media (max-width: 768px)': {
      width: 144,
    },
  },
});

const ProposalBackCover = ({
  setStep,
  setCreateView,
  valuesToEdit,
  proposalData,
  cleanProposalData,
  loadProposalData,
  setProposalSelected,
  saveProposalData,
  updateProposal,
  getProposalsByPage,
  uid,
  setPdfValue,
  listProposals,
  showLoading,
  hideLoading,
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const classes = useStyles();

  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [ending, setEnding] = useState('');

  const validateQuill = (value) => {
    if (value && value !== '<p><br></p>') {
      return true;
    } else {
      return false;
    }
  };

  const fetchPDF = async (blob, proposalData, idProposal) => {
    await uploadPDF(blob, uid, idProposal).then((pdfUrl) => {
      const newProposal = {
        ...proposalData,
        pdfUrl: pdfUrl,
      };
      const proposalToReducer = {
        ...proposalData,
        pdfUrl: pdfUrl,
        id: idProposal,
      }
      const params = {
        uid: uid,
        page: 1,
        limit: 9,
      }
      updateProposalById(newProposal, idProposal, uid);
      if (valuesToEdit && Object.values(valuesToEdit).length > 0) {
        setProposalSelected(proposalToReducer)
      } else {
        loadProposalData(proposalToReducer);
      }
      getProposalsByPage(params);
    })
    .catch(function(error){
      console.log(error)
    })
  };
  
  const validateText = (value) => {
    const regExpStr = "^([A-Za-zäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙñÑ ]{1,35})$"
    const result = new RegExp(regExpStr) 
    if (result.test(value)) {
      return true;
    } else {
      return false;
    }
  };


  const validatesubTitle  = (value) => {
    const regExpStr = "^([A-Za-zäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙñÑ ]{1,45})$"
    const result = new RegExp(regExpStr) 
    if (result.test(value)) {
      return true;
    } else {
      return false;
    }
  };
  

  const handleSubmit = () => {
    showLoading()
    let newProposalData = {};
    if (valuesToEdit && Object.values(valuesToEdit).length > 0) {
      newProposalData = {
        ...valuesToEdit,
        active: true,
        backCover: {
          ...valuesToEdit.backCover,
          title: title,
          subTitle: subtitle,
          closingText: ending,
        },
      };
    } else {
      newProposalData = {
        ...proposalData,
        active: true,
        backCover: {
          ...proposalData.backCover,
          title: title,
          subTitle: subtitle,
          closingText: ending,
        },
      };
    }

    const pdfData = JSON.stringify({
      "urlImgLogo": newProposalData.urlImgLogo,
      "names": newProposalData.names,
      "lastName":  newProposalData.lastName,
      "email": newProposalData.email,
      "phone": newProposalData.phone,
      "state": newProposalData.state,
      "municipality": newProposalData.municipality,
      "direction": newProposalData.direction,
      "coverImage": newProposalData.coverImage,
      "title": newProposalData.title,
      "subTitle": newProposalData.subTitle,
      "introduction": newProposalData.introduction,
      "contact": newProposalData.contact,
      "listServices": newProposalData.listServices,
      "totalPrice": newProposalData.detailsProposal.subtotal,
      "typeCurrency": newProposalData.typeCurrency,
      "discount": newProposalData.detailsProposal.discount,
      "tax": newProposalData.detailsProposal.iva,
      "total": newProposalData.detailsProposal.total,
      "source": newProposalData.source,
      "detailsProposal": newProposalData.detailsProposal,
      "additionalInformation": newProposalData.additionalInformation,
      "backCover": newProposalData.backCover,
      "status": newProposalData.status,
      "active": true,
      "templateNumber": newProposalData.templateNumber,
    });

    if (valuesToEdit && Object.values(valuesToEdit).length > 0) {
      updateProposal(valuesToEdit, listProposals, uid).then(() => {
        var config = {
          method: 'post',
          url: `https://crearpdf.herokuapp.com/pdf/create_pdf?uid=${uid}&idProposal=${valuesToEdit.id}`,
          headers: {
            'Content-Type': 'application/json',
            //'Accept': 'application/pdf',
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${'TgC1n73rN37Gr0u9'}`,
          },
          data: pdfData,
        };

        axios(config)
          .then(function (response) {
            //setPdfValue(response)
            fetch('data:application/pdf;base64,' + response.data.data)
              .then(function (resp) {
                return resp.blob();
              })
              .then(function (blob) {
                // para Yaz fetchPDF(blob)
                fetchPDF(blob, newProposalData, valuesToEdit.id)
                hideLoading();
                setPdfValue(window.URL.createObjectURL(blob));
                //saveAs(blob, `${valuesToEdit.id}.pdf`);
                window.scroll(0, 0);
                setStep(5);
              });
          })
          .catch(function (error) {
            hideLoading();
            console.log('error axios', error);
          });
      });
    } else {
      saveProposalData(newProposalData, uid).then((res) => {
        var config = {
          method: 'post',
          url: `https://crearpdf.herokuapp.com/pdf/create_pdf?uid=${uid}&idProposal=${res.idProposal}`,
          headers: {
            'Content-Type': 'application/json',
            //'Accept': 'application/pdf',
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${'TgC1n73rN37Gr0u9'}`,
          },
          data: pdfData,
        };

        axios(config)
          .then(function (response) {
            //Create a Blob from the PDF Stream
            fetch('data:application/pdf;base64,' + response.data.data)
              .then(function (resp) {
                return resp.blob();
              })
              .then(function (blob) {
                // para Yaz fetchPDF(blob)
                fetchPDF(blob, newProposalData, res.idProposal)
                  .then(() => {
                    hideLoading();
                    window.scroll(0, 0);
                    setStep(5);
                  })
                setPdfValue(window.URL.createObjectURL(blob));
                //saveAs(blob, `${res.idProposal}.pdf`);
                
              });
          })
          .catch(function (error) {
            hideLoading();
            console.log('error axios', error);
          });
      });
    }
  };

  const handleCancel = () => {
    // Si no vas a editar usa esto,
    // sino reinicia los valores iniciales en vez de pasar string vacío
    setTitle('');
    setSubtitle('');
    setEnding('');
    cleanProposalData();
    setCreateView(false);
    window.scroll(0, 0);
  };
  const handleChangeTitle = (event) => {
    setTitle(event.target.value);
  };

  const handleChangeSubtitle = (event) => {
    setSubtitle(event.target.value);
  };

  const handleChangeEnding = (value) => {
    setEnding(value);
  };

  useEffect(() => {
    if (
      valuesToEdit &&
      Object.values(valuesToEdit).length > 0 &&
      valuesToEdit.backCover
    ) {
      valuesToEdit.backCover.title && setTitle(valuesToEdit.backCover.title);
      valuesToEdit.backCover.subTitle &&
        setSubtitle(valuesToEdit.backCover.subTitle);
      valuesToEdit.backCover.closingText &&
        setEnding(valuesToEdit.backCover.closingText);
    }
    if (
      proposalData &&
      Object.values(proposalData).length > 0 &&
      proposalData.backCover
    ) {
      proposalData.backCover.title && setTitle(proposalData.backCover.title);
      proposalData.backCover.subTitle &&
        setSubtitle(proposalData.backCover.subTitle);
      proposalData.backCover.closingText &&
        setEnding(proposalData.backCover.closingText);
    }
  }, []);

  return (
    <>
      <div className="ProposalBackCover">
        <div className="ProposalBackCover_header">
          <div
            className="ProposalBackCover_header_arrowBack"
            onClick={() => setStep(3)}
          >
            <img src="/img/admin/arrow-back.svg" alt="arrow-back" />
            <p>Regresar</p>
          </div>
          <div className="ProposalBackCover_header_title">
            <MainTitle
              title="Contraportada de propuesta económica"
              subtitle="Puedes agregar una contraportada a tu propuesta económica con la siguiente información."
            />
          </div>
        </div>

        <div className="ProposalBackCover_content">
          <div className="ProposalBackCover_content_section">
            <TitlesProfile
              title="Título Contraportada"
              subtitle="Agrega el título para la contraportada de la propuesta económica."
            />
           <TextField
              name={`Titulo`}
              type="text"
              InputLabelProps={{ shrink: true }}
              onChange={handleChangeTitle}
              value={title}
              inputProps={{maxLength :35}}

              helperText={

                ''
              }
              error={
                validationTitle.name
              }

              classes={{ root: classes.TextField }}
              label="Título para la contraportada de la propuesta económica"
              variant="outlined"
              />
          </div>
          <div className="ProposalBackCover_content_section">
            <TitlesProfile
              title="Subtítulo Contraportada"
              subtitle="Agrega el subtítulo para la contraportada de la propuesta económica."
            />
            <TextField
                name={`Subtítulo`}
                type="text"
                InputLabelProps={{ shrink: true }}
                onChange={handleChangeSubtitle}
                value={subtitle}
                inputProps={{maxLength :35}}

                helperText={

                  ''
                }
                error={
                    false
                }
                classes={{ root: classes.TextField }}
                label="Subtítulo para la contraportada de la propuesta económica"
                variant="outlined"
                />
           
          </div>
          <div className="ProposalBackCover_content_section">
            <TitlesProfile
              title="Texto de cierre"
              subtitle="Texto de cierre para exponer un agradecimiento, invitación u observaciones de carácter amplio."
            />
            <ReactQuill
              className="ProposalBackCover_reactQuill"
              theme="snow"
              onChange={handleChangeEnding}
              value={ending}
            />
          </div>

          <div className="ProposalBackCover_content_buttons">
            <ButtonBase
              type="submit"
              onClick={handleSubmit}
              variant="primary"
              linkStyle={classes.linkStyle}
              className={classes.ButtonBase}
              disabled={
                validateText(title) &&
                validatesubTitle(subtitle) &&
                validateQuill(ending)
                  ? false
                  : true
              }
            >
              {isMobile ? 'Guardar' : 'Guardar y continuar'}
            </ButtonBase>

            <ButtonBase
              type="submit"
              onClick={handleCancel}
              variant="primarySolidOutlined"
              linkStyle={classes.linkStyle}
              className={classes.ButtonBase}
            >
              Cancelar
            </ButtonBase>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  uid: state.authClient.uid,
  valuesToEdit: state.proposalsReducer.selectedProposal,
  proposalData: state.proposalsReducer.newProposalData,
  listProposals: state.proposalsReducer.proposals,
});
const mapDispatchToProps = (dispatch) => ({
  cleanProposalData: () => dispatch(cleanProposalData()),
  getProposalsByPage: params => dispatch(getProposalsByPage(params)),
  loadProposalData: (proposalData) => dispatch(loadProposalData(proposalData)),
  setProposalSelected: (proposalData) => dispatch(setProposalSelected(proposalData)),
  saveProposalData: (body, uid) => dispatch(saveProposalData(body, uid)),
  updateProposal: (item, list, uid) =>
    dispatch(updateProposal(item, list, uid)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProposalBackCover);
